import { render, staticRenderFns } from "./modelValuation.vue?vue&type=template&id=204531fe&scoped=true&"
import script from "./modelValuation.vue?vue&type=script&lang=js&"
export * from "./modelValuation.vue?vue&type=script&lang=js&"
import style0 from "./modelValuation.vue?vue&type=style&index=0&id=204531fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204531fe",
  null
  
)

export default component.exports